/**
 * Returns the set of properties belonging to the given object which match the given filter
 *
 * @param obj
 * @param {(x) => boolean} filter
 * @returns {{key: string, value: any}[]}
 */
export function extractProperties(obj: any, filter: (value, key) => boolean = () => true): {key: string, value: any}[] {
    const valueSet = [];
    for (const i in obj) {
        if (obj.hasOwnProperty(i) && filter(obj[i], i)) {
            valueSet.push({key: i, value: obj[i]});
        }
    }
    return valueSet;
}

/**
 * Returns the set of values for all string properties on an object
 *
 * @param obj
 * @returns {Set<string>}
 */
export function extractStringValueSet(obj: any): Set<string> {
    return new Set(
        extractProperties(obj, (value) => typeof value === 'string')
            .map((x) => x.value),
    );
}
